import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { defaultRecordsParams, recordsParamsSchema } from './-SearchParams';
import { RecordsFilters } from './-Filters';
import { recordsQuery } from '~/util/queries/staff/submissions';
import { RecordsTable } from './-RecordsTable';

export const Route = createFileRoute('/_authenticated/staff/_recordsLayout/records/')({
    validateSearch: recordsParamsSchema,
    search: {
        middlewares: [stripSearchParams(defaultRecordsParams)],
    },
    loaderDeps: ({
        search: {
            level,
            list,
            mobile,
            verification,
            submitter,
            page,
            per_page,
            sort,
            reverseSort,
        },
    }) => ({
        level,
        list,
        mobile,
        verification,
        submitter,
        page,
        per_page,
        sort,
        reverseSort,
    }),
    loader: async ({ deps: { list, ...filters }, context: { queryClient } }) =>
        await queryClient.fetchQuery(recordsQuery({ list, filters })),
    component: RouteComponent,
    pendingMs: 3000,
});

function RouteComponent() {
    return (
        <div>
            <RecordsFilters />
            <RecordsTable />
        </div>
    );
}
